import { useEffect, useState, useRef } from 'react'

/**
 * Animação count-up quando o elemento entra na viewport.
 * @param {number} end - Valor final (ex: 100)
 * @param {number} duration - Duração em ms
 * @param {boolean} trigger - Se true, inicia a animação (ex: quando visível)
 */
const CountUp = ({ end, duration = 1500, trigger = true }) => {
  const [count, setCount] = useState(0)
  const rafRef = useRef(null)
  const startRef = useRef(null)

  useEffect(() => {
    if (!trigger) return

    const animate = (timestamp) => {
      if (!startRef.current) startRef.current = timestamp
      const elapsed = timestamp - startRef.current
      const progress = Math.min(elapsed / duration, 1)
      const easeOut = 1 - Math.pow(1 - progress, 3)
      setCount(Math.floor(easeOut * end))

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate)
      }
    }

    rafRef.current = requestAnimationFrame(animate)
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current)
    }
  }, [end, duration, trigger])

  return <span>{count}</span>
}

export default CountUp
